import { Component } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../product-menu-header.component';

@Component({
  selector: 'app-plantlife-one-column-header-empty',
  templateUrl: './menu-header-plantlife-one-column-empty.component.html',
  styleUrls: ['./menu-header-plantlife-one-column-empty.component.scss'],
  providers: [{ provide: ProductMenuHeaderComponent, useExisting: MenuHeaderPlantlifeOneColumnEmptyComponent }],
  standalone: false
})
export class MenuHeaderPlantlifeOneColumnEmptyComponent extends ProductMenuHeaderComponent {}
